import { render, staticRenderFns } from "./ClusterIconMenu.vue?vue&type=template&id=4fa8c09b&scoped=true&"
import script from "./ClusterIconMenu.vue?vue&type=script&lang=js&"
export * from "./ClusterIconMenu.vue?vue&type=script&lang=js&"
import style0 from "./ClusterIconMenu.vue?vue&type=style&index=0&id=4fa8c09b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8c09b",
  null
  
)

export default component.exports